var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEfficiency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4caf50",
    fillOpacity: 1,
    d: "M443.621 86.612L469.124 64.8h-48.025l-67.068-20.625L341.374 57.3l28.686 43.138 13.297 58.801 24.214-23.73c21.736 30 44.429 63.975 44.429 120.546 0 44.553-16.379 87.502-46.899 121.058l29.683 55.523C485.062 385.398 512 323.093 512 256.054c0-69.769-26.102-120.652-68.379-169.442z",
    "data-original": "#00cc71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00cc71",
    d: "M448.7 460.001l-23.701-17.1C377.601 484.599 325.3 511.999 256 511.999c-74.7 0-145.3-34.9-191.8-95.199l45.899-39.6C143.101 423.4 197.8 449.8 256 450.1h.901c56.398 0 87.398-21.301 117.398-40.8L347 390.999l93.3-34.499 8.4 103.501z",
    "data-original": "#00cc71"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#00ab5e",
    d: "M448.7 460.001l-23.701-17.1C377.601 484.599 325.3 511.999 256 511.999V450.1h.901c56.398 0 87.398-21.301 117.398-40.8L347 390.999l93.3-34.499 8.4 103.501z",
    "data-original": "#00ab5e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#4caf50",
    fillOpacity: 1,
    d: "M271 211.3V92.4l-15 26.999L154.501 301.3H241v117.9l15-27.001L357.499 211.3H271z",
    "data-original": "#fbe000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#4caf50",
    fillOpacity: 1,
    d: "M121.874 436.054l-5.654-92.49-20.874 21.255C77.398 334.808 60 305.97 60 256.054c0-51.323 21.125-99.943 60.52-135.745L83.879 72.796C30.209 118.734 0 186.512 0 256.054c0 58.865 18.519 101.136 48.882 145.811l-21.68 17.944 94.672 16.245z",
    "data-original": "#00ab5e"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#00cc71",
    d: "M362 64.8l8.101 35.7c-31.8-26.1-72.1-39.9-114.101-39.9h-.3c-52.5 0-82.299 18.6-112.299 36.601l26.1 19.799L71.1 136.2 75 39.599l22.5 18.9C143.699 22.201 192.1.001 256 .001c61.199 0 119.5 22.5 165.099 64.799H362z",
    "data-original": "#00cc71"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#00ab5e",
    d: "M370.101 100.5c-31.8-26.1-72.1-39.9-114.101-39.9V.001c61.199 0 119.5 22.5 165.099 64.799H362l8.101 35.7z",
    "data-original": "#00ab5e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEfficiency);
export default __webpack_public_path__ + "static/media/efficiency.d13551ae01c94c7159b6910f58773b0c.svg";
export { ForwardRef as ReactComponent };